import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// user management
const UserListPage = lazy(() => import('src/pages/user/list'));
const UserCreatePage = lazy(() => import('src/pages/user/create'));
const UserEditPage = lazy(() => import('src/pages/user/edit'));
// tenant management
const TenantListPage = lazy(() => import('src/pages/tenant/list'));
const TenantCreatePage = lazy(() => import('src/pages/tenant/create'));
const TenantUserListPage = lazy(() => import('src/pages/tenant-user/list'));
const TenantUserCreatePage = lazy(() => import('src/pages/tenant-user/create'));
const TenantUserEditPage = lazy(() => import('src/pages/tenant-user/edit'));
const TenantRlsPage = lazy(() => import('src/pages/tenant/rls'));
// Management User management
const ManagementUserListPage = lazy(() => import('src/pages/management-user/list'));
const ManagementUserCreatePage = lazy(() => import('src/pages/management-user/create'));
const ManagementUserEditPage = lazy(() => import('src/pages/management-user/edit'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const managementRoutes = [
  {
    path: 'users',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <UserListPage />, index: true },
      { path: 'create/', element: <UserCreatePage /> },
      { path: ':id/edit', element: <UserEditPage /> },
    ],
  },
  {
    path: 'management/tenants',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <TenantListPage />, index: true },
      { path: 'create/', element: <TenantCreatePage /> },
      { path: ':id/rls', element: <TenantRlsPage /> },
      // { path: ':id/edit', element: <UserEditPage /> },
    ],
  },
  {
    path: 'management/tenants/:tenantId/users',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <TenantUserListPage />, index: true },
      { path: 'create/', element: <TenantUserCreatePage /> },
      { path: ':id/edit', element: <TenantUserEditPage /> },
    ],
  },
  {
    path: 'management/users',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <ManagementUserListPage />, index: true },
      { path: 'create/', element: <ManagementUserCreatePage /> },
      { path: ':id/edit', element: <ManagementUserEditPage /> },
    ],
  },
];
